import {
		KFC_BRANDS
} from "../../utils"

import { formatInventoryData, handleLastInventory, hasDeclaredStockFor, FRIDGE_FILTERS } from "../../utils/inventoryUtils"

const defaultState = {
		hubs: [],
		inventoryData: [],
	originalInventoryData: [],
		brand: KFC_BRANDS[0].name,
	noDisplay: false,
	selectedStatus: "ALL",
	// KFC-352: which fridge the tiles show. Lives here rather than in the screen because
	// KFC-353 needs it to decide between one and two input bricks.
	fridgeFilter: FRIDGE_FILTERS.ALL,
	nameOrCode: "",
	inventorySnackBar: { open: false, type: "", message: "", duration: 0 },
	inventoryDetailSnackBar: { open: false, type: "", message: "", duration: 0 }
}

export default function (state = defaultState, action) {
	let selectedPosition, newOriginalReceptionData, newInventoryData

		switch (action && action.type) {
				case "INVENTORY_FILTER_LOADED":
						return {
								...state,
								hubs: action.hubs,
								date: action.date
						}
			case "FILTER_BRAND_UPDATED":
				return {
					...state,
					brand: action.brand,
					hubs: action.hubs
				}
				case "INVENTORY_LOADED":
					newOriginalReceptionData = action.originalInventoryData.map(elm => handleLastInventory(elm))
					// KFC-352: every hub starts on both fridges. The pills only show on hubs with a
					// retail offer, so a filter carried over from another hub would be invisible and
					// unreachable — and would empty the screen, since no product there declares a
					// self-service stock.
					newInventoryData = formatInventoryData(filter(newOriginalReceptionData, state.selectedStatus, state.nameOrCode, FRIDGE_FILTERS.ALL))

					return {
								...state,
								hub: state.hubs.filter(elm => elm.objectId === action.hub),
								date: action.date,
								brand: action.brand,
						selectedStatus: state.selectedStatus,
						fridgeFilter: FRIDGE_FILTERS.ALL,
						nameOrCode: state.nameOrCode,
						update: JSON.stringify(newInventoryData),
								inventoryData: newInventoryData,
							originalInventoryData: newOriginalReceptionData
						}

			case "INVENTORY_SELECTED_PRODUCT_STOCK_UPDATED_STATUS":
				selectedPosition = state.originalInventoryData.findIndex(elm => elm.objectId === action.selectedProduct.objectId)
				newOriginalReceptionData = state.originalInventoryData

				if (action.selectedProduct.inventoryStatus !== "IN_PROGRESS") newOriginalReceptionData[selectedPosition] = handleLastInventory(action.selectedProduct)
				newInventoryData = formatInventoryData(filter(newOriginalReceptionData, state.selectedStatus, state.nameOrCode, state.fridgeFilter))

				return {
					...state,
					originalInventoryData: newOriginalReceptionData,
					inventoryData: newInventoryData,
					update: JSON.stringify(newInventoryData),
					noDisplay: (action.noDisplay !== undefined)?action.noDisplay:state.noDisplay
				}
			case "INVENTORY_SELECTED_PRODUCT_STOCK_UPDATED":
				selectedPosition = state.originalInventoryData.findIndex(elm => elm.objectId === action.selectedProduct.objectId)
				newOriginalReceptionData = state.originalInventoryData

				newOriginalReceptionData[selectedPosition] = handleLastInventory(action.selectedProduct)
				newInventoryData = formatInventoryData(filter(newOriginalReceptionData, state.selectedStatus, state.nameOrCode, state.fridgeFilter))

				return {
					...state,
					originalInventoryData: newOriginalReceptionData,
					inventoryData: newInventoryData,
					update: JSON.stringify(newInventoryData),
					inventoryDetailSnackBar: action.inventorySnackBar
				}
				
			case "INVENTORY_FILTER_STATUS_SET":
				newInventoryData = formatInventoryData(filter(state.originalInventoryData, action.inventoryStatus, state.nameOrCode, state.fridgeFilter))

				return {
					...state,
					inventoryData: newInventoryData,
					selectedStatus: action.inventoryStatus,
					update: JSON.stringify(newInventoryData)
				}

			case "INVENTORY_FILTER_FRIDGE_SET":
				newInventoryData = formatInventoryData(filter(state.originalInventoryData, state.selectedStatus, state.nameOrCode, action.fridgeFilter))

				return {
					...state,
					inventoryData: newInventoryData,
					fridgeFilter: action.fridgeFilter,
					update: JSON.stringify(newInventoryData)
				}

			case "INVENTORY_FILTER_NAME_OR_CODE_SET":
				newInventoryData = formatInventoryData(filter(state.originalInventoryData, state.selectedStatus, action.searchFilter, state.fridgeFilter))

				return {
					...state,
					inventoryData: newInventoryData,
					nameOrCode: action.searchFilter,
					update: JSON.stringify(newInventoryData)
				}

			case "INVENTORY_OPEN_DETAIL_SNACKBAR":
			case "INVENTORY_CLOSE_DETAIL_SNACKBAR":
				return {
					...state,
					inventoryDetailSnackBar: action.inventorySnackBar,
					noDisplay: (action.noDisplay !== undefined)?action.noDisplay:state.noDisplay
				}

				case "INVENTORY_OPEN_SNACKBAR":
			case "INVENTORY_CLOSE_SNACKBAR":
				return {
					...state,
					inventorySnackBar: action.inventorySnackBar
				}
				default:
						return {
								...state
						}
		}
}

function filter(result, status, nameOrCode, fridgeFilter) {
	let newResult = result.filter(elm => elm.display)

	// KFC-352: in single-fridge view a product with no stock declared for that fridge has no
	// tile at all. Filtering here, before grouping, keeps empty letter rows and category
	// bands from rendering.
	newResult = newResult.filter(elm => hasDeclaredStockFor(elm, fridgeFilter))

	// filter on status
	if (status !== "ALL") {
		newResult = newResult.filter(elm => elm.inventoryStatus === status)
	}

	// filter on name or code
	const regex = new RegExp(nameOrCode, "ig")
	newResult = newResult.filter(elm =>  (elm.commercialTitle.match(regex) !== null || elm.uniqueCode.match(regex) !== null))

	return newResult
}
